import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { homeFor } from '../auth/gate';
import { PlainFrame } from '../screens/auth/PlainFrame';
import { SignInPage } from '../screens/auth/SignInPage';

const searchSchema = z.object({
  /** Where to go after signing in; app-relative only. */
  next: z
    .string()
    .regex(/^\/(?!\/)/)
    .optional(),
});

/**
 * The fallback: one panel on CapturePoint's canvas, nothing moving. Kept as a page that signs in,
 * so if the hushed composition ever has to go, this is what /sign-in becomes again (Dustin,
 * 2026-09-20: "the current login is our fallback").
 */
export const Route = createFileRoute('/sign-in_/plain')({
  validateSearch: searchSchema,
  beforeLoad: async ({ context }) => {
    const principal = await context.auth.ensureOrNone();
    if (principal) throw redirect(homeFor(principal));
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { next } = Route.useSearch();
  return <SignInPage next={next ?? '/'} Frame={PlainFrame} />;
}
